import React from 'react';
import { Control } from 'react-hook-form';
import { useIntl } from 'react-intl';

import { PaymentInfoForm } from '@/modules/partner/model/form';
import { TextField } from '@src-common/view/adapters/reactHookForm/TextField';

import { messages } from './usMessages';

type Props = {
  control: Control<PaymentInfoForm>;
};

const UsPaymentInfo: React.FC<Props> = ({ control }) => {
  const intl = useIntl();

  return (
    <>
      <TextField
        name="routingNumber"
        title={intl.formatMessage(messages.routingNumberTitle)}
        placeholder="000000000"
        isRequired={true}
        rules={{
          pattern: {
            value: /^\d{9}$/,
            message: intl.formatMessage(messages.routingNumberError),
          },
        }}
        control={control}
      />

      <TextField
        name="accountNumber"
        title={intl.formatMessage(messages.accountNumberTitle)}
        placeholder="00000000"
        isRequired={true}
        rules={{
          pattern: {
            value: /^\d{8,17}$/,
            message: intl.formatMessage(messages.accountNumberError),
          },
        }}
        control={control}
      />

      <TextField
        name="bankName"
        title={intl.formatMessage(messages.bankNameTitle)}
        isRequired={true}
        control={control}
      />
    </>
  );
};

export { UsPaymentInfo };
